import React, { useContext } from 'react';
import cn from 'classnames';
import _get from 'lodash/get';
import _size from 'lodash/size';
import styles from './index.module.scss';

import { If } from 'utils';
import { EcommPlatform, UiKit } from 'components';
import { AuthContext } from 'context/AuthContext';
import { useAppContext } from 'utils/hooks';
import StoreName from '../StoreName';

export default function StoreSelect({ onChange = () => {} }) {
  const { storeProperties, accessToStores } = useContext(AuthContext);
  const { isSSREnv } = useAppContext();

  const storeName = _get(storeProperties, 'store_name', '');
  const storeUniqueName = _get(storeProperties, 'store_unique_name', '');
  const hasMultipleStoreAccess = _size(accessToStores) > 1;

  const { storesList, storePlatformIcon } = accessToStores.reduce(
    (
      acc,
      {
        store_unique_name,
        store_name,
        rr_store_id,
        seller_store_guid,
        ecommerce_platform
      }
    ) => {
      const storeId = isSSREnv ? seller_store_guid : rr_store_id;
      const isSelected = store_unique_name === storeUniqueName;
      if (isSelected) {
        acc.storePlatformIcon = ecommerce_platform;
      } else {
        acc.storesList.push(
          <UiKit.Dropdown.Option
            key={store_unique_name}
            isActive={isSelected}
            onClick={() =>
              !isSelected &&
              onChange({
                id: storeId,
                storeName: store_name,
                storeUniqueName: store_unique_name
              })
            }
          >
            <UiKit.Flex gap={8} align="center">
              <EcommPlatform.Icon
                source={ecommerce_platform}
                className={styles.icon}
              />
              <StoreName name={store_name} uniqueName={store_unique_name} />
            </UiKit.Flex>
          </UiKit.Dropdown.Option>
        );
      }
      return acc;
    },
    { storesList: [], storePlatformIcon: null }
  );

  return (
    <UiKit.Dropdown className={styles.container}>
      <UiKit.Dropdown.Trigger
        caret={hasMultipleStoreAccess}
        className={cn(styles.trigger, {
          [styles.empty]: !hasMultipleStoreAccess
        })}
      >
        <EcommPlatform.Icon
          source={storePlatformIcon}
          className={styles.icon}
        />
        <StoreName name={storeName} uniqueName={storeUniqueName} />
      </UiKit.Dropdown.Trigger>
      <If test={hasMultipleStoreAccess}>
        <UiKit.Dropdown.Menu>
          <UiKit.Dropdown.Option disabled>
            Switch to another store
          </UiKit.Dropdown.Option>
          {storesList}
        </UiKit.Dropdown.Menu>
      </If>
    </UiKit.Dropdown>
  );
}
